// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__17CH6","footer-open":"style_footer-open__fYm7-"};